/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Radio,
  Row,
  Select,
  Collapse,
  Table,
  Input,
  Divider,
} from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

import PageHeading from "../../../../../components/common/PageHeading";
import FilterContainer from "../../../../../components/common/FilterContainer";

import "./paybills.css";
import { FaDollarSign } from "react-icons/fa";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

const PayBills = () => {
  const { Panel } = Collapse;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [expended, setExpended] = useState();
  const [filter, setFilter] = useState("");
  const [isSearchable, setIsSearchable] = useState(false);

  const expend = (index) => {
    if (expended === index) setExpended(undefined);
    else setExpended(index);
  };

  const PayBillsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("Enter Bill", "1", "", "", "/accounting/payables_bills/bills/enter-bils"),
      RightBarMethod("Smart Bill Entry", "2", "", "", "/accounting/payables_bills/bills/smartbillentry"),
      RightBarMethod("Enter Utility Bill (RUBS)", "3", "", "", "/accounting/payables_bills/bills/utility-bill-details"),
      RightBarMethod("Enter Credit", "4", "", "", ""),
      RightBarMethod("Pay Bills", "5", "", "", ""),
      RightBarMethod("Pay Management Fees", "6", "", "", ""),
      RightBarMethod("Pay Owners", "7", "", "", ""),
      RightBarMethod("Tenant Payable", "8", "", "", "/accounting/payables_bills/bills/newtenantpayable"),
      RightBarMethod("Transfer Owner Funds", "9", "", "", ""),
      RightBarMethod("Transfer Funds Between Cash Accounts", "10", "", "", ""),
      RightBarMethod("New Recurring Bill", "11", "", "", "/accounting/payables_bills/recurring_invoices/newrecurringbill"),
      RightBarMethod("Manually Post Bills", "12", "", "", ""),
    ]),
    RightBarMethod(
      "HELP TOPICS",
      "t4",
      <i className="fa-solid fa-circle-question"></i>,
      [
        RightBarMethod("How to Pay Bills", "13", "", "", ""),
        RightBarMethod("How to Sign Up for Online Payables", "14", "", "", ""),
      ]
    ),
  ];

  const tableTopHeader = [
    {
      title: "Payee",
      dataIndex: "payee",
      sorter: true,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      sorter: true,
      width: "auto",
    },
    {
      title: "Due On",
      dataIndex: "dueon",
      sorter: true,
      width: "auto",
    },
    {
      title: "Bill Amount",
      dataIndex: "billamount",
      sorter: true,
      width: "auto",
      align: "right",
      render: (text) => <span className="onclick-text">{text}</span>,
    },

    {
      key: "operation",
      render: (_, record) => {
        return (
          <span className="onclick-text" onClick={() => expend(record.key)}>
            {record.key === expended ? <UpOutlined /> : <DownOutlined />}
          </span>
        );
      },
      width: "auto",
    },
  ];

  const tableAllData = [];
  for (let i = 1; i < 2; i++) {
    tableAllData.push({
      key: 1,
      payee: `Payless Plumbing Inc`,
      reference: `${i * 565}${i * 335}`,
      dueon: `${Math.floor(Math.random() * 12)}/${Math.floor(
        Math.random() * 30
      )}/2023`,
      billamount: `${(
        Math.round((Math.random() * 55 + 155) * 100) / 100
      ).toFixed(2)} `,
    });
  }
  const table2Data = [];
  for (let i = 2; i < 3; i++) {
    table2Data.push({
      key: i,
      payee: `Brewer, Jim`,
      reference: `${i * 565}${i * 335}`,
      dueon: `${Math.floor(Math.random() * 12)}/${Math.floor(
        Math.random() * 30
      )}/2023`,
      billamount: `${(
        Math.round((Math.random() * 55 + 155) * 100) / 100
      ).toFixed(2)} `,
    });
  }

  const table3Data = [];
  for (let i = 3; i < 4; i++) {
    table3Data.push({
      key: i,
      payee: `Integrity Oklahoma LLC`,
      reference: `${i * 565}${i * 335}`,
      dueon: `${Math.floor(Math.random() * 12)}/${Math.floor(
        Math.random() * 30
      )}/2023`,
      billamount: `${(
        Math.round((Math.random() * 55 + 155) * 100) / 100
      ).toFixed(2)} `,
    });
  }

  const table4Data = [];
  for (let i = 4; i < 5; i++) {
    table4Data.push({
      key: i,
      payee: `Integrity Oklahoma LLC`,
      reference: `${i * 565}${i * 335}`,
      dueon: `${Math.floor(Math.random() * 12)}/${Math.floor(
        Math.random() * 30
      )}/2023`,
      billamount: `${(
        Math.round((Math.random() * 55 + 155) * 100) / 100
      ).toFixed(2)} `,
    });
  }

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const onFinish = (values) => {
    console.log('Success:', values);
    setIsSearchable(true)
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const hasSelected = selectedRowKeys.length > 0;
  return (
    <div className="PayBills">
      <PageHeading heading="Pay Bills" />
      <Row>
        <Col span={24}>
          <FilterContainer
            heading={
              "To view bills to pay, select a bank account and click Search."
            }
          >
            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              autoComplete="off"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              colon={false}
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    label="Bank Account"
                    name="BankAccount"
                    rules={[
                        {
                          required: true,
                          message: 'Please select a bank account.',
                        },
                      ]}
                  >
                    <Select
                      options={[
                        { value: "All MICR Bank Accounts" },
                        { value: "All Bank Accounts (Online Payables Only)" },
                        { value: "Rental Income Account (MICR)" },
                        { value: "Security Deposit (MICR)" },
                      ]}
                      placeholder="Choose Bank Account"
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label="Due On or Before">
                    <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Property">
                    <Select
                      options={[
                        { value: "All" },
                        { value: "Paid" },
                        { value: "Unpaid" },
                      ]}
                      placeholder="search by property, group, or portfolio"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="GL Account">
                    <Select
                      options={[
                        { value: "All" },
                        { value: "Pending Approval" },
                        { value: "Approved" },
                      ]}
                      placeholder="Choose GL Account"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Payee Type">
                    <Select
                      options={[
                        { value: "All" },
                        { value: "Pending Approval" },
                        { value: "Approved" },
                      ]}
                      placeholder="Choose Payee Type"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Payee">
                    <Select
                      options={[
                        { value: "All" },
                        { value: "Pending Approval" },
                        { value: "Approved" },
                      ]}
                      placeholder="Search for a specific payee"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Payment Type">
                    <Select
                      options={[
                        { value: "All" },
                        { value: "Pending Approval" },
                        { value: "Approved" },
                      ]}
                      placeholder="Choose Payment Type"
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item label=" ">
                    <Button
                      type="primary"
                      htmlType="submit"
                      
                    >
                      Search
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </FilterContainer>
        </Col>
      </Row>
      {isSearchable ? (
        <>
          <Row gutter={16}>
            <Col>
              <Button type="primary" disabled={hasSelected ? false : true}>
                Continue
              </Button>
            </Col>
            <Col>
              <Button>Cancel</Button>
            </Col>
          </Row>
          <br />
          <Row gutter={16}>
            <Col>
              <Form.Item label="Select:">
                <Radio.Group
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                >
                  <Radio.Button value="All">All</Radio.Button>
                  <Radio.Button value="None">None</Radio.Button>
                  <Radio.Button value="ifFundsAvailable">
                    If Funds Available
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <h4 style={{ textAlign: "right" }}>
            How are Available Funds calculated?
          </h4>
          <Collapse>
            <Panel
              header="Rental Income Account"
              extra="Total Payment Amount: $0.00"
              key="1"
              style={{ background: "#fff" }}
            >
              <a href="#">Select Bills If Funds Available</a>
              <h4>
                1904 Lullaby Lane - 1904 Lullaby Lane Midwest City, OK 73130
              </h4>
              <Table
                rowSelection={rowSelection}
                columns={tableTopHeader}
                dataSource={tableAllData}
                expandable={{
                  expandedRowRender: (record) => (
                    <div>
                      <Form>
                        <Row>
                          <Col span={8}>
                            <Form.Item label="Pay">
                              <Row gutter={16}>
                                <Col>
                                  <Input
                                    addonBefore={<FaDollarSign size={12} />}
                                    defaultValue={record.billamount}
                                  />
                                </Col>
                                <Col>
                                  <Form.Item>of ${record.billamount}</Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                            <Row gutter={16}>
                              <Col>
                                <Button type="primary">Save</Button>
                              </Col>
                              <Col>
                                <Button>Cancel</Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  ),
                  expandIcon: () => <></>,
                }}
                expandedRowKeys={[expended]}
                footer={false}
                pagination={false}
              />
              <Row justify="end" gutter={16}>
                <Col>
                  <Button type="link">
                    <i
                      className="fa-solid fa-right-left"
                      style={{ padding: "5px" }}
                    ></i>
                    Transfer Funds
                  </Button>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>
                    <b>Available Funds:</b>
                  </p>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>$200.00</p>
                </Col>
              </Row>
              <Row justify="end" gutter={16}>
                <Col>
                  <p>Reserve Funds:</p>
                </Col>
                <Col>
                  <p>$200.00</p>
                </Col>
              </Row>

              <h4>9626 SE 4th - 9626 SE 4th Midwest City, OK 73130</h4>
              <Table
                rowSelection={rowSelection}
                columns={tableTopHeader}
                dataSource={table2Data}
                expandable={{
                  expandedRowRender: (record) => (
                    <div>
                      <Form>
                        <Row>
                          <Col span={8}>
                            <Form.Item label="Pay">
                              <Row gutter={16}>
                                <Col>
                                  <Input
                                    addonBefore={<FaDollarSign size={12} />}
                                    defaultValue={record.billamount}
                                  />
                                </Col>
                                <Col>
                                  <Form.Item>of ${record.billamount}</Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                            <Row gutter={16}>
                              <Col>
                                <Button type="primary">Save</Button>
                              </Col>
                              <Col>
                                <Button>Cancel</Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  ),
                  expandIcon: () => <></>,
                }}
                expandedRowKeys={[expended]}
                footer={false}
                pagination={false}
              />
              <Row justify="end" gutter={16}>
                <Col>
                  <Button type="link">
                    <i
                      className="fa-solid fa-right-left"
                      style={{ padding: "5px" }}
                    ></i>
                    Transfer Funds
                  </Button>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>
                    <b>Available Funds:</b>
                  </p>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>$775.00</p>
                </Col>
              </Row>
              <Row justify="end" gutter={16}>
                <Col>
                  <p>Reserve Funds:</p>
                </Col>
                <Col>
                  <p>$0.00</p>
                </Col>
              </Row>

              <h4>test 2 - 1800 canyon park circle edmond, OK 73013</h4>
              <Table
                rowSelection={rowSelection}
                columns={tableTopHeader}
                dataSource={table3Data}
                expandable={{
                  expandedRowRender: (record) => (
                    <div>
                      <Form>
                        <Row>
                          <Col span={8}>
                            <Form.Item label="Pay">
                              <Row gutter={16}>
                                <Col>
                                  <Input
                                    addonBefore={<FaDollarSign size={12} />}
                                    defaultValue={record.billamount}
                                  />
                                </Col>
                                <Col>
                                  <Form.Item>of ${record.billamount}</Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                            <Row gutter={16}>
                              <Col>
                                <Button type="primary">Save</Button>
                              </Col>
                              <Col>
                                <Button>Cancel</Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  ),
                  expandIcon: () => <></>,
                }}
                expandedRowKeys={[expended]}
                footer={false}
                pagination={false}
              />
              <Row justify="end" gutter={16}>
                <Col>
                  <Button type="link">
                    <i
                      className="fa-solid fa-right-left"
                      style={{ padding: "5px" }}
                    ></i>
                    Transfer Funds
                  </Button>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>
                    <b>Available Funds:</b>
                  </p>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>-$325.00</p>
                </Col>
              </Row>
              <Row justify="end" gutter={16}>
                <Col>
                  <p>Reserve Funds:</p>
                </Col>
                <Col>
                  <p>$200.00</p>
                </Col>
              </Row>
              <Divider />
              <Row justify="end">
                <Col>
                  <b>Total Payment Amount: $0.00</b>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <br />
          <Collapse>
            <Panel
              header="Rental Income Account"
              extra="Total Payment Amount: $0.00"
              key="1"
              style={{ background: "#fff" }}
            >
              <a href="#">Select Bills If Funds Available</a>
              <h4>
                1817 Treat Drive - 1817 Treat Drive Midwest City, OK 73110
              </h4>
              <Table
                rowSelection={rowSelection}
                columns={tableTopHeader}
                dataSource={table4Data}
                expandable={{
                  expandedRowRender: (record) => (
                    <div>
                      <Form>
                        <Row>
                          <Col span={8}>
                            <Form.Item label="Pay">
                              <Row gutter={16}>
                                <Col>
                                  <Input
                                    addonBefore={<FaDollarSign size={12} />}
                                    defaultValue={record.billamount}
                                  />
                                </Col>
                                <Col>
                                  <Form.Item>of ${record.billamount}</Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                            <Row gutter={16}>
                              <Col>
                                <Button type="primary">Save</Button>
                              </Col>
                              <Col>
                                <Button>Cancel</Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  ),
                  expandIcon: () => <></>,
                }}
                expandedRowKeys={[expended]}
                footer={false}
                pagination={false}
              />
              <Row justify="end" gutter={16}>
                <Col>
                  <Button type="link">
                    <i
                      className="fa-solid fa-right-left"
                      style={{ padding: "5px" }}
                    ></i>
                    Transfer Funds
                  </Button>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>
                    <b>Available Funds:</b>
                  </p>
                </Col>
                <Col style={{ paddingTop: "8px" }}>
                  <p>$200.00</p>
                </Col>
              </Row>
              <Row justify="end" gutter={16}>
                <Col>
                  <p>Reserve Funds:</p>
                </Col>
                <Col>
                  <p>$200.00</p>
                </Col>
              </Row>
              <Divider />
              <Row justify="end">
                <Col>
                  <b>Total Payment Amount: $0.00</b>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <br />
          <Row gutter={16}>
            <Col>
              <Button type="primary" disabled={hasSelected ? false : true}>
                Continue
              </Button>
            </Col>
            <Col>
              <Button>Cancel</Button>
            </Col>
          </Row>
        </>
      ) : null}
      <div className="RightSidebar">
        <RightBar RightBarData={PayBillsRightBar} />
      </div>
    </div>
  );
};

export default PayBills;
